import { useState } from "react";
import { useGcal } from "@othpwn/performed-cognito-wrapper";

import { useQuery } from "services/Client";
import moment from "moment";

export default function usePaymentChart() {
  const { groups } = useGcal();

  const [startdate, setStartdate] = useState(
    moment().subtract(28, "d").format("YYYY-MM-DD")
  );
  const [enddate, setEnddate] = useState(moment().format("YYYY-MM-DD"));
  const [step, setStep] = useState("d");
  const [hasInsurance, setHasInsurance] = useState(false);
  const { data } = useQuery({
    event: "payment.get.by.day",
    variables: {
      start: startdate,
      end: enddate,
      hasInsurance,
    },
    skip: !groups.includes("administrator"),
  });
  const { data: paymentDataMonth } = useQuery({
    event: "payment.get.by.month",
    variables: {
      start: moment(startdate).set("date", 1).format("YYYY-MM-DD"),
      end: enddate,
      hasInsurance,
    },
    skip: !groups.includes("administrator"),
  });
  const { data: paymentDataYear } = useQuery({
    event: "payment.get.by.year",
    variables: {
      start: moment(startdate)
        .set("date", 1)
        .set("month", 0)
        .format("YYYY-MM-DD"),
      end: enddate,
      hasInsurance,
    },
    skip: !groups.includes("administrator"),
  });
  return {
    data:
      step === "d"
        ? data
        : step === "m"
        ? paymentDataMonth
        : step === "y"
        ? paymentDataYear
        : undefined,
    payload: { startdate, enddate, step, hasInsurance },
    handlers: { setStartdate, setEnddate, setStep, setHasInsurance },
  };
}
